import React, { Component } from "react";
import { Copy, Wrapper, Row, Icon } from "app/NativeComponents/common";
import {
  PopoverMenu,
  InlineButton,
  GhostButton,
  EventCalendar
} from "app/NativeComponents/snippets";

import { store } from "app/store";
import { dismissMobileKeyboard } from "app/NativeActions";
import moment from "moment";

class DateBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      show: false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.show !== prevProps.show &&
      this.props.show != this.state.show
    ) {
      this.setState({
        show: this.props.show
      });
    }

    if (this.state.show !== prevState.show) {
      if (this.state.show) {
        if (this.props.onFocus) {
          this.props.onFocus();
        }
      } else {
        if (this.props.onBlur) {
          this.props.onBlur();
        }
      }
    }
  }

  filterOptions(options) {
    let filtered_options = [];
    const { search } = this.state;
    for (let i = 0; i < options.length; i++) {
      if (
        options[i].label?.toLowerCase().indexOf(search?.toLowerCase()) != -1
      ) {
        filtered_options.push(options[i]);
      }
    }

    return filtered_options;
  }

  renderInner(options) {
    const colors = store.getState().settings.colors;
    const device = store.getState().native.device;
    const {
      style,
      innerStyle,
      placeholder,
      value,
      selected_background_color = null,
      hover_background_color = null,
      forceLabel,
      forceLabelPlaceholder,
      icon = null,
      fa_icon = null,
      hover_icon = null,
      hover_fa_icon = null,

      has_changed = false,
      show_buttons = false,
      secondary_button,
      secondary_button_icon,
      onSecondaryPress = () => {},
      require_confirm = false,
      loading = false,
      onSubmit = () => {},
      submit_button_title = "Save",
      submit_button_icon = "",
      submit_button_primary = false,
      submit_disabled = false,
      error = ""
    } = this.props;
    const { show } = this.state;
    const background_color = show
      ? !!selected_background_color
        ? selected_background_color
        : (require_confirm && has_changed) || error
        ? colors.orange_color_muted
        : colors.active_color_muted
      : (require_confirm && has_changed) || error
      ? colors.orange_color_muted
      : options?.hovering
      ? hover_background_color || colors.hover_color
      : "transparent";
    const hover_icon_color = colors.orange_color;
    const icon_color = colors.text_color;

    return (
      <Row
        style={{
          backgroundColor: background_color,
          alignSelf: "stretch",
          ...style
        }}
      >
        <Wrapper style={{ flex: 1, padding: 25, ...innerStyle }}>
          <Row>
            {!!icon || fa_icon ? (
              <Icon
                size={18}
                color={icon_color}
                icon={icon}
                fa_icon={fa_icon}
                style={{ marginRight: 20 }}
              />
            ) : null}
            <Wrapper style={{ flex: 1 }}>
              {!value && !forceLabel ? (
                <Copy style={{ color: colors.light_text_color }}>
                  {placeholder}
                </Copy>
              ) : (
                <>
                  <Copy
                    style={{
                      color: colors.light_text_color,
                      fontSize: 10,
                      lineHeight: device == "desktop" ? "10px" : 10
                    }}
                  >
                    {placeholder}
                  </Copy>
                  <Copy>
                    {forceLabel && !value ? forceLabelPlaceholder : value}
                  </Copy>
                </>
              )}
            </Wrapper>
            {(!!hover_icon || hover_fa_icon) &&
            options?.hovering &&
            !show &&
            !has_changed ? (
              <Icon
                size={18}
                color={hover_icon_color}
                icon={hover_icon}
                fa_icon={hover_fa_icon}
                style={{ marginLeft: 20 }}
              />
            ) : null}
          </Row>
        </Wrapper>

        {has_changed || show_buttons ? (
          <>
            {!!secondary_button && !loading ? (
              <InlineButton
                disabled={false}
                icon={secondary_button_icon}
                onPress={onSecondaryPress}
              >
                {secondary_button}
              </InlineButton>
            ) : null}

            {submit_button_primary ? (
              <GhostButton
                primary={true}
                disabled={!has_changed ? true : false}
                icon={submit_button_icon}
                onPress={onSubmit}
                loading={loading}
              >
                {submit_button_title}
              </GhostButton>
            ) : (
              <InlineButton
                disabled={!has_changed ? true : false}
                icon={submit_button_icon}
                onPress={onSubmit}
                loading={loading}
              >
                {submit_button_title}
              </InlineButton>
            )}
          </>
        ) : null}
      </Row>
    );
  }

  render() {
    const {
      style,
      placeholder = "",
      popoverPlacement = "bottom",
      value = "",
      date_value = moment().format("YYYY-MM-DD"),
      disabled = false,
      popover_title = "Select a value",
      onFocus = () => {},
      onBlur = () => {}
    } = this.props;

    const colors = store.getState().settings.colors;
    const device = store.getState().native.device;

    const { search, show } = this.state;

    if (disabled) {
      return this.renderInner({ hovering: false });
    }
    return (
      <PopoverMenu
        show={show}
        no_swipe={true}
        no_cancel={true}
        onShow={s => {
          dismissMobileKeyboard();
          this.setState({
            show: s
          });
        }}
        popover_width={350}
        popover_height={400}
        popoverSheetTop={420}
        popoverPlacement={popoverPlacement}
        popover_title={popover_title}
        includeCloseButton={true}
        renderComponent={options => {
          return this.renderInner(options);
        }}
        renderMenu={() => {
          return (
            <>
              <EventCalendar
                selected_date={
                  moment(date_value).format("YYYY-MM-DD") !== "Invalid Date"
                    ? moment(date_value).format("YYYY-MM-DD")
                    : moment().format("YYYY-MM-DD")
                }
                is_selecting_range={false}
                onDateChange={selected_item => {
                  if (device == "mobile" && selected_item?.length > 0) {
                    this.props.onChange(
                      moment(selected_item[0]).format("YYYY-MM-DD")
                    );
                  } else {
                    this.props.onChange(
                      moment(selected_item).format("YYYY-MM-DD")
                    );
                  }

                  this.setState({
                    show: false
                  });
                }}
                onMonthChange={() => {}}
                calendar_events={[]}
                colors={colors}
              />
            </>
          );
        }}
      />
    );
  }
}

export { DateBox };
